import { render, staticRenderFns } from "./SystemCorporate.vue?vue&type=template&id=ad4c73cc&scoped=true&"
import script from "./SystemCorporate.vue?vue&type=script&lang=js&"
export * from "./SystemCorporate.vue?vue&type=script&lang=js&"
import style0 from "./SystemCorporate.vue?vue&type=style&index=0&id=ad4c73cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4c73cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad4c73cc')) {
      api.createRecord('ad4c73cc', component.options)
    } else {
      api.reload('ad4c73cc', component.options)
    }
    module.hot.accept("./SystemCorporate.vue?vue&type=template&id=ad4c73cc&scoped=true&", function () {
      api.rerender('ad4c73cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemCorporate.vue"
export default component.exports